import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let ExportMailboxOption: LazyOption = createLazyOption(
    {
        key: 'exportMailbox',
        titleStringKey: 'optionTitle_export_mailbox',
        searchTermsStringKey: 'optionTitle_export_mailbox',
        isHidden: () => !isFeatureEnabled('fwk-exportMailboxOption'),
        allowedOptionKeys: ['ExportData'],
    },
    lazyFullModule,
    m => m.default
);
export default ExportMailboxOption;
